import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import depositSubscriptionService from '../../services/subscriptions/depositSubscriptionService';
import { showSnack } from './snackbarActions';
import { closeDepositSidePane } from './sidePaneActions';
import { formatErrorText } from '../../helpers/errorTextFormatter';
import config from '../../config';
export var FETCH_PRODUCT_DEPOSIT_TEMPLATES = 'FETCH_PRODUCT_DEPOSIT_TEMPLATES';
export var FETCH_PRODUCT_DEPOSIT_TEMPLATE = 'FETCH_PRODUCT_DEPOSIT_TEMPLATE';
export var RECEIVE_DEPOSIT_TEMPLATES = 'RECEIVE_DEPOSIT_TEMPLATES';
export var RECEIVE_DEPOSIT_TEMPLATES_ERROR = 'RECEIVE_DEPOSIT_TEMPLATES_ERROR';
export var RECEIVE_DEPOSIT_TEMPLATE = 'RECEIVE_DEPOSIT_TEMPLATE';
export var RECEIVE_DEPOSIT_TEMPLATE_ERROR = 'RECEIVE_DEPOSIT_TEMPLATE_ERROR';
export var RECEIVE_DEPOSIT_INFO_ERROR = 'RECEIVE_DEPOSIT_INFO_ERROR';
export var SUBMITTING_DEPOSIT = 'SUBMITTING_DEPOSIT';
export var FETCH_DEPOSIT_INFO = 'FETCH_DEPOSIT_INFO';
export var RECEIVE_DEPOSIT_INFO = 'RECEIVE_DEPOSIT_INFO';
export var RECEIVE_DEPOSIT_TICKET = 'RECEIVE_DEPOSIT_TICKET';
export var RECEIVE_DEPOSIT_TICKETS = 'RECEIVE_DEPOSIT_TICKETS';
export var RESET_DEPOSIT_INFO = 'RESET_DEPOSIT_INFO';
export var RETAIL_FIAT_CONFIRM_DEPOSIT = 'RETAIL_FIAT_CONFIRM_DEPOSIT';
export var ADD_DEPOSIT = 'ADD_DEPOSIT';
export var fetchAllProductDepositTemplates = function fetchAllProductDepositTemplates(ProductId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var product, payload, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isNaN(ProductId)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt('return', dispatch({
                type: RESET_DEPOSIT_INFO
              }));
            case 2:
              // Follow previous deposit workflow for cryptos
              product = getState().apexCore.product.products.find(function (prod) {
                return prod.ProductId === ProductId;
              });
              if (!(product.ProductType === 'CryptoCurrency')) {
                _context.next = 5;
                break;
              }
              return _context.abrupt('return', dispatch(fetchProductDepositTemplate(ProductId)));
            case 5:
              dispatch(fetchingDepositTemplates(ProductId));
              payload = {
                ProductId: ProductId,
                OMSId: getState().user.userInfo.OMSId,
                AccountId: getState().user.selectedAccountId
              };
              _context.next = 9;
              return dispatch(callAPI('GetDepositTemplateTypes', payload)).catch(function () {
                return dispatch(fetchProductDepositTemplate(ProductId));
              });
            case 9:
              data = _context.sent;
              _context.prev = 10;
              if (!data.result) {
                _context.next = 17;
                break;
              }
              if (!(data.TemplateTypes && !data.TemplateTypes.length)) {
                _context.next = 14;
                break;
              }
              return _context.abrupt('return', dispatch(depositTemplatesError('There are no providers configured for this product')));
            case 14:
              dispatch(receiveDepositTemplates(data.TemplateTypes));
              if (data.TemplateTypes && data.TemplateTypes.length === 1) {
                dispatch(fetchProductDepositTemplate(ProductId, data.TemplateTypes[0].TemplateName));
              }
              return _context.abrupt('return', true);
            case 17:
              return _context.abrupt('return', dispatch(depositTemplatesError(data.errormsg)));
            case 20:
              _context.prev = 20;
              _context.t0 = _context['catch'](10);
              dispatch(fetchProductDepositTemplate(ProductId));
            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[10, 20]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var fetchProductDepositTemplate = function fetchProductDepositTemplate(ProductId, TemplateType) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var templateTypeObj, payload, data, _data$Template, UseGetDepositWorkflow, Template, DepositWorkflow;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!isNaN(ProductId)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt('return', dispatch({
                type: RESET_DEPOSIT_INFO
              }));
            case 2:
              dispatch(fetchingDepositTemplate(ProductId, TemplateType));
              templateTypeObj = getState().deposit.templateTypes.find(function (template) {
                return template.TemplateName === TemplateType;
              });
              payload = {
                OMSId: getState().user.userInfo.OMSId,
                AccountId: getState().user.selectedAccountId,
                ProductId: ProductId,
                TemplateType: TemplateType
              };
              if (templateTypeObj) {
                payload.AccountProviderId = templateTypeObj.AccountProviderId;
              }
              _context2.next = 8;
              return dispatch(callAPI('GetDepositRequestInfoTemplate', payload));
            case 8:
              data = _context2.sent;
              if (!data.result) {
                _context2.next = 15;
                break;
              }
              _data$Template = data.Template, UseGetDepositWorkflow = _data$Template.UseGetDepositWorkflow, Template = _data$Template.Template, DepositWorkflow = _data$Template.DepositWorkflow;
              if (Template === '{}' && (UseGetDepositWorkflow || DepositWorkflow === 'CryptoWallet')) {
                dispatch(getDepositInfo(ProductId));
              } else {
                dispatch(depositInfoError('Failed to load'));
              }
              if (Template) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt('return', dispatch(depositTemplateError('Server provided an unexpected response')));
            case 14:
              return _context2.abrupt('return', dispatch(receiveDepositTemplate(data)));
            case 15:
              return _context2.abrupt('return', dispatch(depositTemplateError(data.errormsg)));
            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getDepositInfo = function getDepositInfo(ProductId, template) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var OMSId, AccountId, templateType, templateTypeObj, payload, depositInfo;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              templateType = getState().deposit.templateType;
              templateTypeObj = getState().deposit.templateTypes.find(function (template) {
                return template.TemplateName === templateType;
              });
              payload = {
                OMSId: OMSId,
                AccountId: AccountId,
                ProductId: +ProductId,
                GenerateNewKey: config.Deposit.generateNewKey
              };
              if (templateTypeObj) {
                payload.AccountProviderId = templateTypeObj.AccountProviderId;
              }
              if (template) {
                payload.DepositInfo = template;
              }
              dispatch(fetchingDepositInfo(ProductId));
              _context3.next = 10;
              return dispatch(callAPI('GetDepositInfo', payload));
            case 10:
              depositInfo = _context3.sent;
              if (!depositInfo.result) {
                _context3.next = 13;
                break;
              }
              return _context3.abrupt('return', dispatch(receiveDepositInfo(JSON.parse(depositInfo.DepositInfo))));
            case 13:
              return _context3.abrupt('return', dispatch(depositInfoError(depositInfo.errormsg)));
            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var getDepositTickets = function getDepositTickets() {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var OMSId, AccountId, depositTickets;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              _context4.next = 4;
              return dispatch(callAPI('GetDepositTickets', {
                OMSId: OMSId,
                AccountId: AccountId,
                OperatorId: 1
              }));
            case 4:
              depositTickets = _context4.sent;
              return _context4.abrupt('return', dispatch(receiveDepositTickets(depositTickets)));
            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var createDepositTicket = function createDepositTicket(_ref5) {
  var ProductId = _ref5.ProductId,
    amount = _ref5.amount,
    TemplateType = _ref5.TemplateType,
    info = _objectWithoutProperties(_ref5, ['ProductId', 'amount', 'TemplateType']);
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var OMSId, AccountId, UseGetDepositWorkflow, DepositInfo, payload, depositStatus;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              UseGetDepositWorkflow = getState().deposit.templateInfo.UseGetDepositWorkflow;
              DepositInfo = JSON.stringify(info);
              payload = {
                OMSId: OMSId,
                OperatorId: 1,
                AccountId: AccountId,
                RequestUser: AccountId,
                AssetId: +ProductId,
                Amount: amount ? amount : +info.Amount,
                DepositInfo: DepositInfo,
                Status: 'New'
              };
              dispatch(submittingDeposit);
              if (!UseGetDepositWorkflow) {
                _context5.next = 8;
                break;
              }
              return _context5.abrupt('return', dispatch(getDepositInfo(ProductId, DepositInfo)));
            case 8:
              _context5.next = 10;
              return dispatch(callAPI('CreateDepositTicket', payload));
            case 10:
              depositStatus = _context5.sent;
              if (!(depositStatus.result === false)) {
                _context5.next = 13;
                break;
              }
              return _context5.abrupt('return', dispatch(showSnack({
                id: 'depositRejectSnack',
                text: formatErrorText(depositStatus),
                type: 'warning'
              })));
            case 13:
              dispatch(closeDepositSidePane());
              // context.t('Your deposit has been successfully added')
              dispatch(getDepositTickets());
              if (!config.Deposit.showDepositIdModal) {
                dispatch(showSnack({
                  id: 'depositSuccessSnack',
                  text: 'Your deposit has been successfully added',
                  type: 'success'
                }));
              }
              return _context5.abrupt('return', dispatch(receiveDepositTicket(depositStatus)));
            case 17:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));
    return function (_x9, _x10) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export { createDepositTicket };
export var subscribeToDeposits = function subscribeToDeposits() {
  return function (dispatch) {
    depositSubscriptionService.subscribe(function (updates) {
      dispatch(addDeposit(updates));
    });
  };
};
export var addDeposit = function addDeposit(payload) {
  return {
    type: ADD_DEPOSIT,
    payload: payload
  };
};
export var fetchingDepositTemplates = function fetchingDepositTemplates(product) {
  return {
    type: FETCH_PRODUCT_DEPOSIT_TEMPLATES,
    payload: {
      product: product
    }
  };
};
export var fetchingDepositTemplate = function fetchingDepositTemplate(product, templateType) {
  return {
    type: FETCH_PRODUCT_DEPOSIT_TEMPLATE,
    payload: {
      product: product,
      templateType: templateType
    }
  };
};
export var fetchingDepositInfo = function fetchingDepositInfo(product) {
  return {
    type: FETCH_DEPOSIT_INFO,
    payload: {
      product: product
    }
  };
};
export var receiveDepositTemplates = function receiveDepositTemplates(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATES,
    payload: payload
  };
};
export var receiveDepositTemplate = function receiveDepositTemplate(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATE,
    payload: payload
  };
};
export var depositTemplatesError = function depositTemplatesError(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATES_ERROR,
    payload: payload
  };
};
export var depositTemplateError = function depositTemplateError(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATE_ERROR,
    payload: payload
  };
};
export var depositInfoError = function depositInfoError(payload) {
  return {
    type: RECEIVE_DEPOSIT_INFO_ERROR,
    payload: payload
  };
};
export var submittingDeposit = {
  type: SUBMITTING_DEPOSIT
};
export var receiveDepositInfo = function receiveDepositInfo(payload) {
  return {
    type: RECEIVE_DEPOSIT_INFO,
    payload: payload
  };
};
export var receiveDepositTicket = function receiveDepositTicket(payload) {
  return {
    type: RECEIVE_DEPOSIT_TICKET,
    payload: payload
  };
};
export var receiveDepositTickets = function receiveDepositTickets(payload) {
  return {
    type: RECEIVE_DEPOSIT_TICKETS,
    payload: payload
  };
};